import React from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { ProgressBar } from 'react-bootstrap';
import $ from 'jquery';
import useFetch from '../hooks/useFetch';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import Permission from './RoleManagement/Permission';
export default function Overview() {

  const percentagecircle = 66;

  const { data, isLoading } = useFetch('dashboard')
  const navigate = useNavigate();

  const handleClick = (id) => {
    const route = `/goaldetailpage`;
    navigate(route, { state: { id } });
  };

  if (isLoading) {
    return (
      <>
        <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
          <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
            <h1 className="h2"> <i className="fa-solid fa-spinner fa-spin"></i></h1>
          </div>
        </main>
      </>
    )
  }

  const delayed = data?.goal_status?.delayed
  const in_progress = data?.goal_status?.in_progress
  const completed = data?.goal_status?.completed

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  };

  // Sort goals by start_date in descending order (newest first)
  const sortedRecentGoals = data.recent_goals
    ? [...data.recent_goals].sort((a, b) => new Date(b.start_date) - new Date(a.start_date))
    : [];

  return (
    <>

      <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">

        <div className='overview-main'>
          <div className='overview-header'>
            <h1 className='h2'>Overview</h1>
            <div className='buttons-right'>
              <Permission access={"/creategoal"}>
              <Link to="/creategoal">
                <button className='btn btn-primary btn-add'> <i class="fa-regular fa-square-plus"></i> Create Goal</button>
                </Link>
              </Permission>
              <Permission access={"/importreport"}>
                <Link to="/importreport"><button className='btn btn-light'> <i class="fa-solid fa-file-import"></i> Import Reports</button></Link>
              </Permission>
            </div>
          </div>
          <div className='overview-body'>
            <div className='row'>
              <div className='col-md-9'>
                <div className='overview-tiles'>
                  <div className='overview-tile'>
                    <h4>Total Goal Created</h4>
                     <div className='bigtext'>
                      <span> {data.total_goals} </span>
                      <Permission access={"/goal"}><Link to="/goal">View All</Link></Permission>
                    </div>
                    <Permission access={"/goal"}><Link to="/goal"><span className='arrow-right'><i class="fa-solid fa-arrow-right"></i></span></Link></Permission>
                  </div>
                  <div className='overview-tile'>
                    <h4>Internal Teams </h4>
                    <div className='bigtext'>
                      <span> {data.internal_teams} </span>
                      <Permission access={"/teammanagement"}><Link to="/teammanagement" state={"employee"}>View All</Link></Permission>
                    </div>
                    <Permission access={"/teammanagement"}><Link to="/teammanagement" state={"employee"} ><span className='arrow-right'><i class="fa-solid fa-arrow-right"></i></span></Link></Permission>
                  </div>
                  <div className='overview-tile'>
                    <h4>External team</h4>
                    <div className='bigtext'>
                      <span> {data.external_teams} </span>
                      <Permission access={"/teammanagement"}><Link to="/teammanagement" state={"supplier"}>View All</Link></Permission>
                    </div>
                    <Permission access={"/teammanagement"}><Link to="/teammanagement" state={"supplier"} ><span className='arrow-right'><i class="fa-solid fa-arrow-right"></i></span></Link></Permission>
                  </div>
                  <div className='overview-tile'>
                    <h4>Stake Holder</h4>
                    <div className='bigtext'>
                      <span> 0 </span>
                      <Link>View All</Link>
                    </div>
                    <span className='arrow-right'><i class="fa-solid fa-arrow-right"></i></span>
                  </div>
                </div>
              </div>
              <div className='col-md-3'>
                <div className='goal-status'>
                  <h4>Goal Status</h4>
                  <div className='progress-status'>
                    <span>Delayed</span>
                    <ProgressBar now={20} variant="danger" label={`${delayed} `} />
                    <span>Early</span>
                    <ProgressBar now={20} variant="info" label={`${in_progress} `} />
                    <span>On Track</span>
                    <ProgressBar now={60} variant="success" label={`${completed} `} />

                  </div>
                  <Permission access={"/goal"}><Link to="/goal">View All</Link></Permission>
                  <Permission access={"/goal"}><Link to="/goal"><span className='arrow-right'><i class="fa-solid fa-arrow-right"></i></span></Link></Permission>
                </div>
              </div>
            </div>
          </div>
          <Permission access={"/goal"}>
          <div className='overview-table'>
              <div className='row mt-3'>
                <div className='col-sm-12'>
                  <h4 className='goalcreatetableheading'>Latest Goal Created</h4>
                  <div className='latestgoalcreted'>
                    <table className="table">
                      <thead className="table-dark table-dark-blue">
                        <tr>
                          <th scope="col">Goal Name</th>
                          <th scope="col">Category</th>
                          <th scope="col">Start Date</th>
                          <th scope="col">End Date</th>
                          <th scope="col">Status</th>
                          <th scope="col">% Complete</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sortedRecentGoals.length > 0 ? (
                          sortedRecentGoals.map((curData) => {
                            const { id, goal_name, category, start_date, end_date, status } = curData;
                            const randomPercentage = Math.floor(Math.random() * 101);
                            return (
                              <tr className="clickable"
                                key={id}
                                onClick={() => handleClick(id)}
                              >
                                <td scope="row">{goal_name}</td>
                                <td>{category}</td>
                                <td>{formatDate(start_date)}</td>
                                <td>{formatDate(end_date)}</td>
                                <td>{status}</td>
                                <td className='circlep'>
                                  <CircularProgressbar value={randomPercentage} text={`${randomPercentage}%`} />
                                </td>
                              </tr>
                            );
                          })
                        ): (
                          <tr>
                            <td colSpan="6">No goals data available.</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </Permission>
        </div>
      </main>
    </>
  );
}
